import type { Notification } from '@/types/notification.types';
import { dashboardRoutePaths } from '@/routes/route-config';

/**
 * Where an "x-ray uploaded" notice opens: the visit's Images tab when the
 * upload was linked to a visit, otherwise the patient's Files tab.
 */
export function xrayUploadPath(
  n: Pick<Notification, 'resourceType' | 'resourceId'>,
): string | null {
  if (!n.resourceId) return null;
  switch (n.resourceType) {
    case 'reservation':
      return `${dashboardRoutePaths.reservationDetails.replace(
        ':appointmentId',
        n.resourceId,
      )}?tab=images`;
    case 'patient':
      return `${dashboardRoutePaths.patientProfile.replace(
        ':patientId',
        n.resourceId,
      )}?tab=files`;
    default:
      return null;
  }
}
